module.exports = __webpack_public_path__ + "img/news_2.1ddf3576.jpg";